<!--
 * @Author: your name
 * @Date: 2020-07-24 17:04:48
 * @LastEditTime: 2020-08-08 16:17:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/lib/ui/components/x-input-search/x-input-search.vue
-->
<template>
  <div class="x-input-search">
    <form class="form" action="javascript:;">
      <cube-input
        :placeholder="placeholder"
        v-model="searchStr"
        type="search"
        :clearable="false"
        @input="handlerInput"
        @keyup.enter.native="handlerSearch"
      >
        <template slot="prepend">
          <x-svg-icon name="search-icon"></x-svg-icon>
        </template>
      </cube-input>
    </form>
  </div>
</template>

<script>
export default {
  name: 'XInputSearch',
  props: {
    placeholder: {
      type: String,
      default: "搜索数据"
    }
  },
  data() {
    return {
      searchStr: "",
      searchDebounce: this.$lodash.debounce(function (e) {
        this.$emit("search", this.searchStr)
      }, 400)
    }
  },
  methods: {
    handlerInput() {
      this.searchDebounce()
    },
    
    handlerSearch() {
      this.searchDebounce()
    }
  }
}
</script>

<style lang="scss">
.x-input-search {
  height: 2.28rem;
  display: flex;
  align-items: center;
  background-color: $--app-light-color;
  padding: .71rem 1.14rem;
  .form {
    width: 100%;
    height: 100%;
    .cube-input {
      padding-right: 0.71rem;
      flex: 1;
      border-radius: 1.15rem;
      height: 100%;
      background-color: $--app-body-bgColor;
      overflow: hidden;
      &::after {
        border: 0;
      }
      .cube-input-prepend {
        line-height: 1;
        padding: 0.43rem  0.43rem 0.43rem 1rem;
      }
      &.cube-input_active::after {
        border: 0;
      }
      input {
        font-size: 1rem;
      }
    }
    input[type=search]::-webkit-search-cancel-button{
      -webkit-appearance: none;  //此处去掉默认的小×
    }
  }
}
</style>